export function randomString(): string {
  return Math.floor(Math.random() * 2 ** 32).toString(16)
}

/**
 * Generates random int in inclusive range between [min, max].
 *
 * Seed can be used to alter default Math.random() result - useful for
 * deterministic testing.
 */
export function randomInt(min: number, max: number, seed?: number): number {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor((seed ?? Math.random()) * (max - min + 1)) + min
}

/**
 * Generates a random ID.
 *
 * This function prioritizes using the cryptographically strong `crypto.randomUUID()`
 * method when available in a secure context.
 *
 * In non-secure contexts (e.g., HTTP or when `crypto.randomUUID` is unavailable),
 * it falls back to a less secure method using `Math.random()`. This fallback
 * is primarily intended for debugging and local development environments where
 * a cryptographically secure UUID is not strictly necessary.
 *
 * @returns {string} A randomly generated ID.
 */
export function generateRandomID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    // Secure context and crypto.randomUUID is available.
    return crypto.randomUUID()
  }

  // Fallback for non-secure contexts or when crypto.randomUUID is not available
  return randomString()
}
